import FontHeading5 from '../../../../../../../components/fonts/font-heading5/font-heading5';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import CustomCollapsible from '../../ui/custom-collapsible/custom-collapsible';
import EligibilityStatusBadge from '../../ui/eligibility-status-badge';
import { OrderEligibilityDisplayService, ItemEligibilityDto } from '../../order-eligibility-display.service';

import ItemCardContent from './item-card-content';

interface OrderItemCardProps {
    item: ItemEligibilityDto;
    index: number;
    policyFilter: string;
}

const OrderItemCard: React.FC<OrderItemCardProps> = ({ item, index, policyFilter }) => {
    const policyResults = OrderEligibilityDisplayService.getItemPolicyResults(item, policyFilter);
    const failedChecks = OrderEligibilityDisplayService.getFailedEligibilityChecks(item, policyFilter);
    const isEligible = OrderEligibilityDisplayService.isItemEligible(item);
    
    // Get eligible policy evaluations (filtered by policy filter if provided)
    const eligiblePolicyEvaluations = OrderEligibilityDisplayService.getEligiblePolicyEvaluations(item, policyFilter);

    return (
        <CustomCollapsible
            key={item.line_item_id || index}
            title={
                <FontHeading5 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                    {OrderEligibilityDisplayService.formatItemTitle(item)}
                </FontHeading5>
            }
            rightContent={
                <EligibilityStatusBadge isEligible={isEligible} />
            }
            isExpanded={false}
            level="primary"
        >
            <ItemCardContent 
                item={item}
                isEligible={isEligible}
                eligiblePolicyEvaluations={eligiblePolicyEvaluations}
                failedChecks={failedChecks}
                policyResults={policyResults}
            />
        </CustomCollapsible>
    );
};

export default OrderItemCard;
